module.exports = __webpack_public_path__ + "img/f1.c6a59ad4.png";